<template>

  <div class="tabs" >
  			<el-tabs v-model="activeName" type="card" >
          <el-tab-pane label="年度工资汇总" name="first">
					<annualSummary />
  				</el-tab-pane>

          <el-tab-pane label="年度工资明细" name="second">
            <annualDetails />
  				</el-tab-pane>
  			</el-tabs>
  		</div>

</template>

<script>

  import annualDetails from "./annualDetails.vue";
  import annualSummary from "./annualSummary.vue";

  export default {
    name: "averageWage",
    data(){
      return{
        activeName:'first',

        // dialogheaderVisible:false,
      }
    },
    created(){

    },
    mounted(){

    },
    components: {annualSummary,annualDetails},
    methods:{

    }
  };
</script>
<style scoped="scoped">
	.tabs>>>#tab-second {
		left: -20px;
		z-index: 9;
	}
</style>
